import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../Interceptor";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const GetCurrencySymbol = ({ currencyId }) => {
  const [currencySymbol, setCurrencySymbol] = useState("");

  useEffect(() => {
    const getAllCurrencies = async () => {
      try {
        const { data: currencyData } = await api.get(
          `${API_BASE_URL}/api/v1/getAllCurrencies`
        );

        const matchedCurrency = currencyData.find(
          (currency) => currency._id === currencyId
        );
        if (matchedCurrency) {
          setCurrencySymbol(matchedCurrency.symbol);
        } else {
          setCurrencySymbol("N/A");
        }
      } catch (error) {
         if (error?.isUnpaid) {
      return; 
    }
        toast.error("Oops! Error while fetching Currencies");
      }
    };

    if (currencyId) {
      getAllCurrencies();
    }
  }, [currencyId]);

  return <span>{currencySymbol}</span>;
};

export default GetCurrencySymbol;
